__turbopack_context__.v({
  "background-image": "CoreHomeHero-module-scss-module__Kg6daW__background-image",
  "container": "CoreHomeHero-module-scss-module__Kg6daW__container",
  "content": "CoreHomeHero-module-scss-module__Kg6daW__content",
  "hover-image": "CoreHomeHero-module-scss-module__Kg6daW__hover-image",
  "hover-video": "CoreHomeHero-module-scss-module__Kg6daW__hover-video",
  "link": "CoreHomeHero-module-scss-module__Kg6daW__link",
  "links": "CoreHomeHero-module-scss-module__Kg6daW__links",
  "main": "CoreHomeHero-module-scss-module__Kg6daW__main",
  "with-hero-image": "CoreHomeHero-module-scss-module__Kg6daW__with-hero-image",
});
